/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "SalesReportPageService";
const log: any = LoggerModule.getInstance();

export class SalesReportPageService {
  private static instance: SalesReportPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private headers: any;
  private token: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }

  public static getInstance(props: any = {}): SalesReportPageService {
    if (!SalesReportPageService.instance) {
      SalesReportPageService.instance = new SalesReportPageService(props);
    }
    return SalesReportPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getCostume(args?: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getCostume(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    compProps = await agent.getPresentationListsProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }
  public async getPresentation(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getPresentationListsProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }
}
